import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from 'contentful'

export interface TypeSeoFields {
  path?: EntryFieldTypes.Symbol
  title?: EntryFieldTypes.Symbol
  description?: EntryFieldTypes.Text
  keywords?: EntryFieldTypes.Array<EntryFieldTypes.Symbol>
  ogImage?: EntryFieldTypes.AssetLink
  canonical?: EntryFieldTypes.EntryLink<TypeSeoSkeleton>
  noIndex?: EntryFieldTypes.Boolean
  noFollow?: EntryFieldTypes.Boolean
  jsonLd?: EntryFieldTypes.Object
}

export type TypeSeoSkeleton = EntrySkeletonType<TypeSeoFields, 'seo'>
export type TypeSeo<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<
  TypeSeoSkeleton,
  Modifiers,
  Locales
>

export function isTypeSeo<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
  entry?: Entry<EntrySkeletonType, Modifiers, Locales> | undefined
): entry is TypeSeo<Modifiers, Locales> {
  return entry?.sys?.contentType?.sys?.id === 'seo'
}
